import React from "react";

export default function ButtonIcon({ className, onClick, icon, alt, id }) {
  return (
    <button className={className} onClick={onClick} id={id}>
      <img src={icon} alt={`icon-${alt}`} />
    </button>
  );
}
